import React from 'react'
import "./SalesCard.css"


function SalesCard({
    heading="",
    cardData=[],
    noteText="",
    noteList,
    twoCard=false
}) {
  return (
    <div className='SalesCard-container standard-padding-space pt-2'>
        <div className='container'>
            <div className='text-content text-center'>
                <h3 className='body-heading' style={{textTransform:"uppercase"}}>{heading}</h3>

            </div>

            <div className='row mt-4 pt-3 gy-lg-0 gy-4 justify-content-center'>
                {
                    cardData.map((ele)=>{
                        return(
                            <div className={` ${twoCard ? "col-lg-6": "col-lg-4"} `}>
                                <div className='card-box p-4' >
                                    <h5 className='sub-heading color-dark text-center mb-4' style={{fontSize:"1.4rem",fontWeight:"500"}}>{ele.title}</h5>

                                    <ul className=''>
                                        {
                                            ele.list.map((listData)=>{
                                                return(
                                                    <li className='color-dark mb-2'>{listData}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        )
                    })
                }

            </div>

            {
                noteText &&
                <p className='body-paragraph text-center mt-5'><b>Note:</b> {noteText}</p>
            }
            {
                noteList &&
                <>
                <p className='body-paragraph text-start mt-5'><b>Note:</b></p>
                 <ul className='ps-3'>
                    {
                        noteList.map((listData)=>{
                            return(
                                <li className='color-dark mb-2'>{listData}</li>
                            )
                        })
                    }
                </ul>
                </>
            }
        </div>
    </div>
  )
}

export default SalesCard